<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> 'BreadCrumbs' - Row -->
            <div class="row">
                <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                <sdr-breadcrumbs active_item="second" :module="modulo"></sdr-breadcrumbs>
                <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
            </div>
            <!-- <<< 'BreadCrumbs' - Row -->

            <!-- >>> 'Passengers' - Row -->
            <div class="row">
                <!-- >>>  Left Side: : 'Passengers' -->
                <form @submit.prevent="onSubmit">
                    <div class="container shortcode travel-ideas">
                        <h1 class="idea-title" style="margin-bottom:20px;" v-if="get_areWeInServicesBookingNoMode === false">
                            <span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ pleaseselectservicesheadline[getCurrentLocale] }}
                        </h1>
                        <h1 class="idea-title" style="margin-bottom:20px;" v-if="get_areWeInServicesBookingNoMode === true">
                            <span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ pleaseselectservicesheadlineinbookinno[getCurrentLocale] }}
                        </h1>
                    </div>

                    <div id="main" class="col-sms-6 col-sm-8 col-md-9">
                        <!-- >>> VueCmp - 'sdr-passenger', 'Single Passenger' -->
                        <sdr-passenger :modulo="modulo"></sdr-passenger>
                        <!-- <<< VueCmp - 'sdr-passenger', 'Single Passenger' -->

                        <br />
                        <button type="submit" class="btn-large icon-check uppercase full-width" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }" v-if="getFlagBookingPassengersAreReadyForValidation === true">{{ proceed[getCurrentLocale] }}</button>
                        <a class="button btn-large uppercase full-width silver" v-if="getFlagBookingPassengersAreReadyForValidation !== true">{{ proceed[getCurrentLocale] }}</a>
                    </div>

                </form>
                <!-- <<<  Left Side: : 'Passengers' -->


                <!-- >>>  Right Side: Sidebar, 'Passengers' -->
                <div class="sidebar col-sms-6 col-sm-4 col-md-3">
                    <!-- >>> VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                    <sdr-shared-cart :modulo="modulo"></sdr-shared-cart>
                    <!-- <<< VueCmp - 'sdr-shared-cart', 'Shared Cart' -->

                    <!-- >>> VueCmp - 'sdr-contact-box', 'Contact Box' -->
                    <sdr-contact-box></sdr-contact-box>
                    <!-- <<< VueCmp - 'sdr-contact-box', 'Contact Box' -->
                </div>
                <!-- <<<  Right Side: Sidebar, 'Passengers' -->
            </div>
            <!-- <<< 'Passengers' - Row -->
        </div>
    </section>
</template>

<script>
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import Passenger from '../../booking/passengers/Passenger.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue';
    import SharedCart from '../../shared/cart/Cart.vue';

    import axios from 'axios';
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-passenger': Passenger,
            'sdr-contact-box': ContactBox,
            'sdr-shared-cart': SharedCart,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                pleaseselectservicesheadline: {
                    en: 'Step 2: Please provide passenger details and select services.',
                    de: 'Schritt 2: Bitte Passagierdaten eingeben und Services auswählen.'
                },
                pleaseselectservicesheadlineinbookinno: {
                    en: 'Step 2: Please select your additional services.',
                    de: 'Schritt 2: Bitte Ihre zusätzlichen Services auswählen.'
                },
                needhelp: {
                    en: 'Do you need any help?',
                    de: 'Brauchen Sie Hilfe?',
                },
                sideboxhelptext: {
                    en: 'We will be happy to help you. Our team consultants are at your disposal around the clock.',
                    de: 'Wir helfen Ihnen gerne weiter. Unsere Teamberater stehen Ihnen rund um die Uhr zur Verfügung.',
                },
                proceed: {
                    en: 'PROCEED TO PAYMENT INFORMATION',
                    de: 'WEITER ZU ZAHLUNGSDETAILS',
                },
                pleasselectaservice: {
                    en: 'Please select at least one service!',
                    de: 'Bitte wählen Sie mindestens einen Service aus!',
                },
                // currentLocale: 'de',
                // >>> --------------------------
                validateParams: {} //
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_areWeInServicesBookingNoMode',
                'getBookingCart',
                'getBookingFlightIdSelectedOutward',
                'getBookingFlightIdSelectedReturn',
                'getBookingLockfaresResults',
                'getFlagBookingPassengersAreReadyForValidation',
                'getBookingUsersSearchData',
                'getBookingLockfaresResults',
                'getBookingCartOutwardTotal',
                'getBookingCartReturnTotal',
                'getBookingCartCountServices', // #340
                // >>> --------------------------
                'get_ServicesBookingnoSearchResults',
                'getServicesValidatePassengersObject'
            ]),


            /*******************************************************************
            * validateParamsData
            *
            * Desc: 'Validate Passengers Object' for Call of same Name.
            * Note:
            *
            */
            validateParamsData : {

                get() {
                    return this.validateParams;
                },
                set(value) {
                    this.validateParams = value;
                }

            }, // eof validateParamsData{}

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_setBookingValidatePassengersObject', // set: 'Calls Object to send'
                'actn_setBookingUpdateCartWithPaxCredentials', // set: Update Cart with Pax Credentials
                // >>> --------------------------
                'actn_setServicesValidatePassengersObject', // (same for 'Services')
                'actn_setServicesValidatePassengersObjectClone', // (same for 'Services', Clone)
            ]),


            /******************************************************************* 'ServiceCalls - Booking'
            * ServiceCalls: 'Booking'
            *******************************************************************/
            /*******************************************************************
            * Call::'/booking/validatepassengers/', HTTP Method PUT
            *
            * Desc:
            * Note: This Call Response is a special Case:
            * Note: It may contain errors!
            * Note: Errors gets translated here!
            *
            */
            call_validatePassengers: function(params) {

                var me = this,
                    hdrs = '',
                    options = {},
                    trsnltd = '';


                me.$toc('>>> booking/passengers/Passengers.vue >>> call_validatePassengers');
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/booking/validatepassengers/', params)
                    .then(function(response) { // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                if (response.data.validated === false) { // ERROR
                                    trsnltd = me.$trnsl_error_message(response.data.errors[0]);
                                    me.$toasted.global.sdr_app_error({
                                        message : trsnltd
                                    });
                                } else {
                                    me.$vp_um();

                                    me.$router.push({ path: '/payment/' + me.modulo  });

                                    setTimeout(function() {
                                        me.$scrollTo('#scrollPointTop', 200, options);
                                    }, 300);
                                }
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo function call_validatePassengers()




            /******************************************************************* 'ServiceCalls - Services'
            * ServiceCalls: 'Services'
            *******************************************************************/
            /*******************************************************************
            * Call::'/registration/validate', HTTP Method PUT
            *
            * Desc:
            * Note: This Call Response is a special Case:
            * Note: It may contain errors!
            * Note: Errors gets translated here!
            *
            * @param {Object} params
            */
            call_validateInRegistration: function(params) {

                var me = this,
                    hdrs = '',
                    options = {},
                    trsnltd = '';


                me.$toc('>>> booking/passengers/Passengers.vue >>> call_validateInRegistration');
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/registration/validate/', params)
                    .then(function(response) { // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                if (response.data.validated === false) { // ERROR
                                    trsnltd = me.$trnsl_error_message(response.data.errors[0]);
                                    me.$toasted.global.sdr_app_error({
                                        message : trsnltd
                                    });
                                } else {
                                    me.$vp_um();

                                    me.$router.push({ path: '/payment/' + me.modulo  });

                                    setTimeout(function() {
                                        me.$scrollTo('#scrollPointTop', 200, options);
                                    }, 300);
                                }
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_validateInRegistration()




            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: 'Passengers Form' gets submitted.
            * Note: I build an Object for Update Cart only here!
            * Note: Build some 'ValidatePassengersObject' Clone here.
            *
            * @param {Object} submitEvent (Event)
            * @return {Array} infantServices
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    myValidateParams = {},
                    myUpdateCartWithCredentialsParams = {}, // for Update Cart only
                    pax = {},
                    day = null,
                    month = null,
                    year = null,
                    counter = 1,
                    countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                    countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                    countINF = parseFloat(this.getBookingUsersSearchData.noINF),
                    countADTCHD = countADT + countCHD,
                    countADTCHDINF = countADTCHD + countINF;


                me.$toc('>>> booking/passengers/Passengers.vue >>> onSubmit');
                myValidateParams.bookingKeyCode = this.getBookingLockfaresResults.keycode;
                myValidateParams.passengers = [];
                myUpdateCartWithCredentialsParams.passengers = [];

                // >>> Catch every Pax Data (ADT) ------------------------------
                for (var i = 1; i <= countADT; i++) {
                    pax.salutation = submitEvent.target.elements['inputPax_salutation_' + i].value;
                    pax.firstName = submitEvent.target.elements['inputPax_firstName_' + i].value;
                    pax.middleName = '';
                    pax.lastName =  submitEvent.target.elements['inputPax_lastName_' + i].value;
                    pax.gender = submitEvent.target.elements['inputPax_salutation_' + i].value == 'MR' ? 'M' : 'F';
                    day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                    month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                    year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;
                    pax.birthdate = moment(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000');

                    // >>> ----------------------
                    pax.infantServices = this.buildValidateParams_InfantSrvcs(submitEvent, i);  // i === id_pax
                    pax.services = this.buildValidateParams_Srvcs(i); // i === id_pax
                    pax.seatServices = this.buildValidateParams_Seats(i); // i === id_pax
                    // <<< ----------------------

                    myValidateParams.passengers.push(pax); // add ADT

                    // >>> ---------------------- Special
                    pax.id_pax = counter;
                    myUpdateCartWithCredentialsParams.passengers.push(pax); // add ADT
                    // <<< ----------------------

                    pax = {}; // reset
                    counter = counter + 1;
                }

                // >>> Catch every Pax Data (CHD) ------------------------------
                for (var i = countADT + 1; i <= countADTCHD; i++) {
                    pax.salutation = 'CHD';
                    pax.firstName = submitEvent.target.elements['inputPax_firstName_' + i].value;
                    pax.middleName = '';
                    pax.lastName = submitEvent.target.elements['inputPax_lastName_' + i].value;
                    pax.gender = submitEvent.target.elements['inputPax_gender_' + i].value;
                    day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                    month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                    year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;
                    pax.birthdate = moment(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000');

                    // >>> ----------------------
                    pax.infantServices = []; // no
                    pax.services = this.buildValidateParams_Srvcs(i); // i === id_pax
                    pax.seatServices = this.buildValidateParams_Seats(i); // i === id_pax
                    // <<< ----------------------

                    myValidateParams.passengers.push(pax); // add CHD

                    // >>> ---------------------- Special
                    pax.id_pax = counter;
                    myUpdateCartWithCredentialsParams.passengers.push(pax); // add CHD
                    // <<< ----------------------

                    pax = {}; // reset
                    counter = counter + 1;
                }

                // >>> Catch every Pax Data (INF) - ONLY FOR CART!!! -----------
                if (this.modulo === 'booking') {
                    for (var i = countADTCHD + 1; i <= countADTCHDINF; i++) {
                        pax.salutation = 'CHD';
                        pax.firstName = submitEvent.target.elements['inputPax_firstName_' + i].value;
                        pax.middleName = '';
                        pax.lastName = submitEvent.target.elements['inputPax_lastName_' + i].value;
                        pax.gender = submitEvent.target.elements['inputPax_gender_' + i].value;
                        day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                        month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                        year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;
                        pax.birthdate = moment(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000');

                        // >>> ----------------------
                        pax.infantServices = []; // no
                        pax.services = [];
                        pax.seatServices = []; // later
                        // <<< ----------------------

                        // >>> ---------------------- Special
                        pax.id_pax = counter;
                        myUpdateCartWithCredentialsParams.passengers.push(pax); // add CHD
                        // <<< ----------------------

                        pax = {}; // reset
                        counter = counter + 1;
                    }
                }


                // >>> Step 4: Add/Set/Call ------------------------------------
                this.actn_setBookingValidatePassengersObject(myValidateParams); // Save...
                this.actn_setBookingUpdateCartWithPaxCredentials(myUpdateCartWithCredentialsParams); // Save... fo Update Cart only


                // >>> The right next Call -------------------------------------
                if (this.modulo === 'booking') {
                    this.call_validatePassengers(myValidateParams); // Next...
                }

                if (this.modulo === 'services') {
                    if (this.getBookingUsersSearchData.rTrip === true) {        // Roundtrip
                        if (this.getBookingCartCountServices === 0) { // some srvc in cart?, Old: this.getBookingCartOutwardTotal === 0 && this.getBookingCartReturnTotal === 0
                            me.$toasted.global.sdr_app_error({
                                message :  this.pleasselectaservice[this.getCurrentLocale]
                            });
                            return;
                        }
                    }
                    if (this.getBookingUsersSearchData.rTrip === false) {       // Oneway
                        if (this.getBookingCartCountServices === 0) { // some srvc in cart?, Old: this.getBookingCartOutwardTotal === 0
                            me.$toasted.global.sdr_app_error({
                                message :  this.pleasselectaservice[this.getCurrentLocale]
                            });
                            return;
                        }
                    }

                    delete myValidateParams.bookingKeyCode;                     // not in 'services'


                    // >>> ----------------------                               // clone for bookinno
                    if (this.get_areWeInServicesBookingNoMode === true) {
                        let deepClone = JSON.parse(JSON.stringify(myValidateParams));
                        this.actn_setServicesValidatePassengersObjectClone(deepClone);
                    }
                    // <<< ----------------------

                    let deepClone = JSON.parse(JSON.stringify(myValidateParams));
                    me.actn_setServicesValidatePassengersObject(deepClone); // Save... (with id)

                    for (var i = 0; i < myValidateParams.passengers.length; i++) { // not in 'services'
                        delete myValidateParams.passengers[i].id_pax;
                    }

                    this.call_validateInRegistration(myValidateParams); // Next...
                }

            }, // eo function onSubmit()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * buildValidateParams_Srvcs()
            *
            * Desc: Build 'services' Array for 'validatePassengers' Params.
            * Note:
            * Note: NEW (03.2020), Add older Bookingno Srvcs too here!
            * Note: Pay Attention: SEAT does not belong into services[] !
            *
            * @param {Int} id_pax ()
            * @return {Array} services
            */
            buildValidateParams_Srvcs: function(id_pax) {

                let me = this,
                    services = [];


                me.$toc('>>> booking/passengers/Passengers.vue >>> buildValidateParams_Srvcs');
                // >>> Searching 'Cart' --------- a)
                for (var i = 0; i < this.getBookingCart.length; i++) {
                    if (parseFloat(id_pax, 10) === parseFloat(this.getBookingCart[i].id_pax, 10)) {
                        for (var a = 0; a < this.getBookingCart[i].outward_srvcs.length; a++) {
                            services.push({
                                code: this.getBookingCart[i].outward_srvcs[a].code,
                                comment: this.getBookingCart[i].outward_srvcs[a].userInputSrvcsDetails_Comment,
                                idFlight: this.getBookingFlightIdSelectedOutward,
                                quantity: parseFloat(this.getBookingCart[i].outward_srvcs[a].userInputSrvcsDetails_Count, 10) + parseFloat(this.get_ServicesFromOriginalBooking(id_pax, this.getBookingFlightIdSelectedOutward, this.getBookingCart[i].outward_srvcs[a].code), 10),
                            });
                        }

                        for (var b = 0; b < this.getBookingCart[i].return_srvcs.length; b++) {
                            services.push({
                                code: this.getBookingCart[i].return_srvcs[b].code,
                                comment: this.getBookingCart[i].return_srvcs[b].userInputSrvcsDetails_Comment,
                                idFlight: this.getBookingFlightIdSelectedReturn,
                                quantity: parseFloat(this.getBookingCart[i].return_srvcs[b].userInputSrvcsDetails_Count, 10) + parseFloat(this.get_ServicesFromOriginalBooking(id_pax, this.getBookingFlightIdSelectedReturn, this.getBookingCart[i].return_srvcs[b].code), 10),
                            });
                        }
                    }
                }

                // >>> Mode: Bookinno ----------- b)
                if (this.get_areWeInServicesBookingNoMode === true) {
                    this.get_ServicesBookingnoSearchResults[0].passengers.forEach((pax, i) => {
                        if (parseFloat(id_pax, 10) === parseFloat(this.getBookingCart[i].id_pax, 10)) {
                            pax.outboundServices.forEach((srvcs, i) => {
                                if (srvcs.code !== 'SEAT') {
                                    services.push({
                                        code: srvcs.code,
                                        comment: '',
                                        idFlight: this.getBookingFlightIdSelectedOutward,
                                        quantity: srvcs.quantity,
                                    });
                                }
                            });

                            pax.inboundServices.forEach((srvcs, i) => {
                                if (srvcs.code !== 'SEAT') {
                                    services.push({
                                        code: srvcs.code,
                                        comment: '',
                                        idFlight: this.getBookingFlightIdSelectedReturn,
                                        quantity: srvcs.quantity,
                                    });
                                }
                            });
                        }
                    });
                }


                return services;

            }, // eo function buildValidateParams_Srvcs()

            /*******************************************************************
            * buildValidateParams_Seats()
            *
            * Desc: Build 'seats' Array for 'validatePassengers' Params.
            * Note:
            *
            * @param {Int} id_pax ()
            * @return {Array} seats
            */
            buildValidateParams_Seats: function(id_pax) {

                let me = this,
                    services = [];


                me.$toc('>>> booking/passengers/Passengers.vue >>> buildValidateParams_Seats');
                // >>> Searching 'Cart' --------- a)
                for (var i = 0; i < this.getBookingCart.length; i++) {
                    if (parseFloat(id_pax, 10) === parseFloat(this.getBookingCart[i].id_pax, 10)) {

                        if (this.getBookingCart[i].outward_seat.price !== undefined) {
                            services.push({
                                code: this.getBookingCart[i].outward_seat.code,
                                comment: this.getBookingCart[i].outward_seat.comment,
                                idFlight: this.getBookingCart[i].outward_seat.id_flight,
                                quantity: this.getBookingCart[i].outward_seat.quantity,
                                tktClass: this.getBookingCart[i].outward_seat.tktClass,
                                infantOnLap: this.getBookingCart[i].outward_seat.infantOnLap,
                                lockingCode: this.getBookingCart[i].outward_seat.lockingcode,
                                seatName: this.getBookingCart[i].outward_seat.seatno,
                            });
                        }

                        if (this.getBookingCart[i].return_seat.price !== undefined) {
                            services.push({
                                code: this.getBookingCart[i].return_seat.code,
                                comment: this.getBookingCart[i].return_seat.comment,
                                idFlight: this.getBookingCart[i].return_seat.id_flight,
                                quantity: this.getBookingCart[i].return_seat.quantity,
                                tktClass: this.getBookingCart[i].return_seat.tktClass,
                                infantOnLap: this.getBookingCart[i].return_seat.infantOnLap,
                                lockingCode: this.getBookingCart[i].return_seat.lockingcode,
                                seatName: this.getBookingCart[i].return_seat.seatno,
                            });
                        }
                    }
                }


                return services;

            }, // eo function buildValidateParams_Seats()

            /*******************************************************************
            * buildValidateParams_InfantSrvcs()
            *
            * Desc: Build 'infantServices' Array for 'validatePassengers' Params.
            * Note:
            *
            * @param {Object} submitEvent (Event)
            * @param {Int} id_pax ()
            * @return {Array} infantServices
            */
            buildValidateParams_InfantSrvcs: function(submitEvent, id_pax) {

                let me = this,
                    infantServices = [],
                    pax = {},
                    day = null,
                    month = null,
                    year = null,
                    countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                    countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                    countINF = parseFloat(this.getBookingUsersSearchData.noINF),
                    countADTCHD = countADT + countCHD,
                    countADTCHDINF = countADTCHD + countINF;


                me.$toc('>>> booking/passengers/Passengers.vue >>> buildValidateParams_InfantSrvcs');
                if (this.modulo === 'booking') {
                    // >>> -----------------------------------------------------
                    if (countINF === 0) {
                        infantServices = [];
                    }

                    // >>> -----------------------------------------------------
                    if (countINF !== 0) {
                        // >>> Step 1: Catch every Pax Data (INF) ------------------
                        for (var i = countADTCHD + 1; i <= countADTCHDINF; i++) {

                            // >>> Arrange adults to a baby ------------------------
                            if (i === parseFloat(id_pax) + parseFloat(countADTCHD)) {

                                // >>> Infant Srvcs on OUT -----
                                if (this.getBookingFlightIdSelectedOutward !== null) {
                                    day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                                    month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                                    year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;

                                    infantServices.push({
                                        birthdate: moment(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000'),
                                        firstName: submitEvent.target.elements['inputPax_firstName_' + i].value,
                                        gender: submitEvent.target.elements['inputPax_gender_' + i].value,
                                        lastName: submitEvent.target.elements['inputPax_lastName_' + i].value,
                                        middleName: '',
                                        tktClass: 'Y',
                                        quantity: 1,
                                        idFlight: this.getBookingFlightIdSelectedOutward
                                    });
                                }

                                // >>> Infant Srvcs on RET -----
                                if (this.getBookingFlightIdSelectedReturn !== null) {
                                    day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                                    month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                                    year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;

                                    infantServices.push({
                                        birthdate: moment(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000'),
                                        firstName: submitEvent.target.elements['inputPax_firstName_' + i].value,
                                        gender: submitEvent.target.elements['inputPax_gender_' + i].value,
                                        lastName: submitEvent.target.elements['inputPax_lastName_' + i].value,
                                        middleName: '',
                                        tktClass: 'Y',
                                        quantity: 1,
                                        idFlight: this.getBookingFlightIdSelectedReturn
                                    });
                                }
                            }
                        }
                    }
                }


                return infantServices;

            }, // eo function buildValidateParams_InfantSrvcs()


            /*******************************************************************
            * get_ServicesFromOriginalBooking()
            *
            * Desc:
            * Note: Special for Mode:Bookingno. Add Services only Quantity.
            * Note: Return Quantity AND Delete index from Array.
            *
            * @param {Number} id_pax
            * @param {Number} idFlight
            * @param {String} code
            * @return {Number} 'Some Count for some Service'
            */
            get_ServicesFromOriginalBooking: function(id_pax, idFlight, code) {

                var me = this,
                    quantity = 0;


                me.$toc('>>> booking/passengers/Passengers.vue >>> get_ServicesFromOriginalBooking');
                if (this.get_areWeInServicesBookingNoMode === true) {
                    this.get_ServicesBookingnoSearchResults[0].passengers.forEach((pax, i) => {
                        if (parseFloat(pax.id_pax_own, 10) === parseFloat(id_pax, 10)) {
                            pax.outboundServices.forEach((srvcs, i) => {
                                if (srvcs.code !== 'SEAT') {
                                    if (idFlight === this.getBookingFlightIdSelectedOutward) {
                                        if (srvcs.code === code) {
                                            quantity = srvcs.quantity;
                                            pax.outboundServices.splice(i, 1);
                                        }

                                    }
                                }
                            });

                            pax.inboundServices.forEach((srvcs, i) => {
                                if (srvcs.code !== 'SEAT') {
                                    if (idFlight === this.getBookingFlightIdSelectedReturn) {
                                        if (srvcs.code === code) {
                                            quantity = srvcs.quantity;
                                            pax.inboundServices.splice(i, 1);
                                        }

                                    }
                                }
                            });
                        }
                    });
                }


                return quantity;

            }, // eo function get_ServicesFromOriginalBooking()

        }, // eo methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4a6e89;
    }

    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.5em;
        }

        button.btn-large,
        input[type='button'].button.btn-large,
        a.button.btn-large {
            font-size: 1em;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/booking/passengers/Passengers.vue